import React from 'react';
import { HighlightedLinksType } from '../../../../../types/globalSettingsType';
import { HighlightedLink } from './HighlightedLinkItem/HighlightedLinkItem';
import * as S from './HighligtedLinks.styles';

interface HighlightedLinksProps {
  link?: HighlightedLinksType | null;
}

const HighlightedLinks = ({ link }: HighlightedLinksProps) => {
  if (!link || typeof link !== 'object' || !link.link) return null;

  return (
    <S.MenuItem>
      <HighlightedLink item={link} />
    </S.MenuItem>
  );
};

export default HighlightedLinks;
